import "./WazawanHistoryItem.css";
import { PromptPair, Wazawan } from "./Wazawan";
import { WazawanReportingPreview } from "./WazawanReportingPreview";
import { WazawanAssetPreview } from "./WazawanAssetPreview";
import { WazawanFormPreview } from "./WazawanFormPreview";
import { WazawanFormFillPreview } from "./WazawanFormFillPreview";
import { WazawanResponseToolbar } from "./WazawanResponseToolbar";
import { WazawanQandAPreview } from "./WazwanQandAPreview";
import { useState } from "react";
import { X } from "lucide-react";

type WazawanHistoryItemProps = {
  id: string;
  promptPair: PromptPair;
  onExpand: (promptPair: PromptPair) => void;
};

export const WazawanHistoryItem = ({
  id,
  promptPair,
  onExpand,
}: WazawanHistoryItemProps) => {
  console.log("WazawanHistoryItem promptPair: ", promptPair);

  const [showJSONSidebar, setShowJSONSidebar] = useState<boolean>(false);

  // const parsed = JSON.parse(promptPair.response);

  let parsed = {};

  try {
    parsed = JSON.parse(promptPair.response);
  } catch (e) {
    parsed = promptPair.response;
  }

  const isObject =
    parsed !== null && typeof parsed === "object" && !Array.isArray(parsed);

  return (
    <div id={promptPair.id} className="wazawan-history-item">
      {/* <div className="wazawan-history-item-user">
                <img src={AVATAR_USER} alt="avatar" /> Niel
            </div> */}
      <div className="wazawan-history-item-prompt">{promptPair.prompt}</div>
      {/* <div className="wazawan-history-item-user">
                <img src={AVATAR_WINSLOW} alt="avatar" /> Winslow
            </div> */}
      {promptPair.type === "reporting" && (
        <div className="wazawan-history-prompt-response">
          {!isObject && promptPair.response}
          {isObject && (
            <div
              className="wazawan-history-prompt-response-object"
              onClick={() => setShowJSONSidebar(!showJSONSidebar)}>
              JSON Object
            </div>
          )}
        </div>
      )}
      <div className="wazawan-history-preview">
        {(() => {
          switch (promptPair.type) {
            case "general":
              return (
                <div className="wazawan-history-general">
                  <WazawanQandAPreview
                    promptPair={promptPair}
                    onExpand={() => onExpand(promptPair)}
                  />
                  {/* {JSON.parse(promptPair.response).answer} */}
                </div>
              );
            case "reporting":
              return (
                <div className="wazawan-history-preview">
                  <WazawanReportingPreview
                    promptPair={promptPair}
                    onExpand={() => onExpand(promptPair)}
                  />
                </div>
              );
            case "asset":
              return (
                <div className="wazawan-history-preview">
                  <WazawanAssetPreview
                    promptPair={promptPair}
                    onExpand={() => onExpand(promptPair)}
                  />
                </div>
              );
            case "ui":
              return (
                <div className="wazawan-history-preview">
                  <WazawanFormPreview
                    promptPair={promptPair}
                    onExpand={() => onExpand(promptPair)}
                  />
                </div>
              );
            case "open":
              return (
                <div className="wazawan-history-open">
                  {/* <pre> */}
                  {promptPair.response}
                  {/* </pre> */}
                </div>
              );
            case "form fill":
              return (
                <div className="wazawan-history-form-fill">
                  <WazawanFormFillPreview
                    promptPair={promptPair}
                    onExpand={() => onExpand(promptPair)}
                  />
                </div>
              );
            default:
              return <></>;
          }
        })()}
      </div>
      <div className="wazawan-history-item-toolbar">
        <WazawanResponseToolbar key={"toolbar-" + id} promptPair={promptPair} />
      </div>

      {showJSONSidebar && (
        <div className="wazawan-history-json-sidebar">
          <pre>{JSON.stringify(parsed, null, 2)}</pre>
          <div className="wazawan-history-json-sidebar-close">
            <X size={24} onClick={() => setShowJSONSidebar(false)} />
          </div>
        </div>
      )}
    </div>
  );
};
